<template>
  <div class="prizeresult-box">
    <img src="../../assets/images/drugPrize/suc.jpg" alt="">
    <div class="suc">预约成功</div>
    <div class="desc">{{text}}</div>
    <van-button class="btn" type="primary" block @click="handleDown" color="#4F7DFF">下载便捷青岛</van-button>
  </div>
</template>

<script>
import { Button } from 'vant'

export default {
  components: {
    [Button.name]: Button
  },
  data () {
    return {
      loading: false,
      text: '您已成功预约抽奖活动，中签结果将于2021年6月25日公布，您可以通过“活动页面-查看抽奖结果”查询中签结果'
    }
  },
  methods: {
    handleDown () {
      if (window._czc) {
        window._czc.push(['_trackEvent', '海天琴岛通', '预约成功下载', '预约成功页', '', '002'])
      }
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.bsit.coband'
    }
  }
}

</script>
<style lang='scss' scoped>
.prizeresult-box {
  padding-top: 85px;
  line-height: 1.6;
  text-align: center;
  margin: 20px;
  img {
    width: 50px;
    margin: 5px 15px 12px;
  }
  .suc {
    margin-bottom: 8px;
    font-size: 16px;
    color:#333;
    text-align: center;
  }
  .desc {
    font-size: 14px;
    color: #757575;
    text-align: center;
  }
  .btn {
    height: 40px;
    border: none;
    outline: none;
    margin-top: 25px;
    border-radius: 5px;
    color: #fff;
    font-size: 15px;
  }
}
</style>
